import { gql } from '@grandvisionhq/graphql';
import { checkoutMutationResult } from '../fragments/checkout-mutation-result.js';
import { unknownUpdateCartFailure } from '../fragments/cart-mutation-failures.js';
import '../fragments/recreate-ordered-checkout-failure.js';
import '../fragments/recreate-ordered-checkout-result.js';
import '../fragments/paypal-payment.js';
import '../fragments/saved-user-details.js';

const SET_STORE = gql`
  mutation SetStore($storeInput: CheckoutStoreInput!) {
    setStore(storeInput: $storeInput) {
      ...CheckoutMutationResultFragment
      failures {
        ...UnknownUpdateCartFailureFragment
      }
    }
  }
  ${checkoutMutationResult}
  ${unknownUpdateCartFailure}
`;

export { SET_STORE };
//# sourceMappingURL=set-store.js.map
